<template>
  <cms-custom-html
    :theme="theme"
    :is-preview="true"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

defineOptions({
  name: 'ViewCustomCode',
});

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const store = useStore();

const getTheme = computed(() => store.getters.getTheme);
const getGlobalThemeSettings = computed(() => store.getters.getGlobalThemeSettings);
const getComponentTranslation = computed(() => store.getters['translation/getComponentTranslation']);

const theme = computed(() => ({
  ...getTheme.value.containers[props.containerIdx].components[props.componentIdx].options,
  translations: getComponentTranslation.value('custom_html'),
  globalThemeSettings: getGlobalThemeSettings.value,
}));
</script>
